import { intersect } from "@/utils/collections"

export default {
  namespaced: true,
  state: {
    tasks: {},
  },
  getters: {
    tasks: state => state.tasks,
    getRunningItemTypes: state => ({ cloud_construction_id, item_types }) => {
      const currentItemTypes = state.tasks[cloud_construction_id]
      if(!currentItemTypes) return null

      const runningItemTypes = intersect(currentItemTypes, item_types)
      if(runningItemTypes.length < 1){
        return null
      }
      return runningItemTypes;
    }
  },
  mutations: {
    setTasks(state, tasks){
      state.tasks = tasks
    },
    addTask(state, { cloud_construction_id, item_type }) {
      const curTasks = state.tasks
      const curItemTypes = 
        curTasks[cloud_construction_id] ? curTasks[cloud_construction_id] : []
      const added = [ item_type, ...curItemTypes ]
      const uniq = [...new Set(added)]
      state.tasks[cloud_construction_id] = uniq
      state.tasks = Object.assign({}, state.tasks, state.tasks)
    },
    deleteTask(state, { cloud_construction_id, item_type }) {
      const curTasks = state.tasks
      const curItemTypes = 
        curTasks[cloud_construction_id] ? curTasks[cloud_construction_id] : []
      const deleted = curItemTypes.filter(itm => itm !== item_type)
      const uniq = [...new Set(deleted)]
      state.tasks[cloud_construction_id] = uniq
      state.tasks = Object.assign({}, state.tasks, state.tasks)
    },
  },
  actions: {
    clearTasks({ commit }){
      commit('setTasks', {})
    },
    startTasks({ commit }, { cloud_construction_id, item_types }){
      item_types.forEach(item_type => {
        commit('addTask', { cloud_construction_id, item_type })
      })
    },
    finishTask({ commit }, { cloud_construction_id, item_type }){
      commit('deleteTask', { cloud_construction_id, item_type })
    },
  }
}
